var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCityBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.25C16.5188 1.25 17.75 2.48122 17.75 4V12.0003H16.25V4C16.25 3.30964 15.6904 2.75 15 2.75L10 2.75002C10 2.75002 10 2.75002 10 2.75002C9.30965 2.75003 8.75 3.30968 8.75 4.00002V22.0001H7.25V4.00002C7.25 2.48124 8.48122 1.25003 9.99999 1.25002L15 1.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83934 12.1358C2.21734 11.6318 2.7968 11.25 3.5 11.25C4.2032 11.25 4.78266 11.6318 5.16066 12.1358C5.53849 12.6395 5.75 13.3011 5.75 14C5.75 14.6989 5.53849 15.3605 5.16066 15.8642C4.78266 16.3682 4.2032 16.75 3.5 16.75C2.7968 16.75 2.21734 16.3682 1.83934 15.8642C1.46151 15.3605 1.25 14.6989 1.25 14C1.25 13.3011 1.46151 12.6395 1.83934 12.1358ZM3.03934 13.0358C2.87427 13.2559 2.75 13.5943 2.75 14C2.75 14.4057 2.87427 14.7441 3.03934 14.9642C3.20423 15.1841 3.37477 15.25 3.5 15.25C3.62523 15.25 3.79577 15.1841 3.96066 14.9642C4.12573 14.7441 4.25 14.4057 4.25 14C4.25 13.5943 4.12573 13.2559 3.96066 13.0358C3.79577 12.8159 3.62523 12.75 3.5 12.75C3.37477 12.75 3.20423 12.8159 3.03934 13.0358Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74609 22V16H4.24609V22H2.74609Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 6C10.75 5.58579 11.0858 5.25 11.5 5.25H13.5C13.9142 5.25 14.25 5.58579 14.25 6C14.25 6.41421 13.9142 6.75 13.5 6.75H11.5C11.0858 6.75 10.75 6.41421 10.75 6ZM10.75 9C10.75 8.58579 11.0858 8.25 11.5 8.25H13.5C13.9142 8.25 14.25 8.58579 14.25 9C14.25 9.41421 13.9142 9.75 13.5 9.75H11.5C11.0858 9.75 10.75 9.41421 10.75 9Z",
    fill: "#76B72A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18.25C17.4142 18.25 17.75 18.5858 17.75 19V22C17.75 22.4142 17.4142 22.75 17 22.75C16.5858 22.75 16.25 22.4142 16.25 22V19C16.25 18.5858 16.5858 18.25 17 18.25Z",
    fill: "#76B72A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5492 11.4006C16.8162 11.1998 17.1838 11.1998 17.4508 11.4006L21.4508 14.4093C21.6392 14.551 21.75 14.773 21.75 15.0087V22C21.75 22.4142 21.4142 22.75 21 22.75C20.5858 22.75 20.25 22.4142 20.25 22V15.383L17 12.9385L13.75 15.383V22C13.75 22.4142 13.4142 22.75 13 22.75C12.5858 22.75 12.25 22.4142 12.25 22V15.0087C12.25 14.773 12.3608 14.551 12.5492 14.4093L16.5492 11.4006Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCityBuildings);
export default __webpack_public_path__ + "static/media/ic-city-buildings.65102fc3f48afd775fd2b573a025c709.svg";
export { ForwardRef as ReactComponent };